<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Parameter Setups &nbsp;
          <add-button
            link="/planned-maintenance/parameter-setups/create"
          ></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Planned Management</li>
          <li class="breadcrumb-item">Parameter Setups</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body row">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
          <!-- Export To Excel -->
          <div class="col-md-4">
            <div style="float: right">
              <a
                href="#"
                class="btn btn-primary"
                v-if="ExportparameterSetups.length == 0"
                @click="exportToExcel"
              >
                <span v-if="isExcelloading">
                  <div class="d-flex align-items-center">
                    <strong>Generating Excel</strong>
                    &nbsp;
                    <div
                      class="
                        spinner-border
                        text-light
                        spinner-border-sm
                        ms-auto
                      "
                      role="status"
                      aria-hidden="true"
                    ></div>
                  </div>
                </span>
                <span v-else>Generate Excel</span>
              </a>
              <download-excel
                :title="title"
                v-else
                class="btn btn-success"
                :data="parameterSetups_excel"
                :fields="excel_fields"
                worksheet="Parameter Setups"
                name="Parameter Setup.xls"
                >Download Excel
              </download-excel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Vessel Name</th>
                    <th>Title</th>
                    <th>Machinary Group</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="parameterSetups.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr
                    v-for="(parameterSetup, at) in parameterSetups"
                    :key="`parameterSetup${at}`"
                  >
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>
                      {{
                        parameterSetup.vessel ? parameterSetup.vessel.name : ""
                      }}
                    </td>
                    <td>{{ parameterSetup.title }}</td>
                    <td>
                      {{
                        parameterSetup.machinery_group
                          ? parameterSetup.machinery_group.name
                          : ""
                      }}
                    </td>
                    <td>
                      <div>
                        <router-link
                          :to="`/planned-maintenance/parameter-setups/${parameterSetup.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(parameterSetup.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "parameterSetup",
  data() {
    return {
      parameterSetups: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      parameterSetups_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        "Vessel Name": "vessel_name",
        Title: "title",
        "Machinary Group": "machinary_group",
      },
      ExportparameterSetups: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let parameterSetups = await axios.get(
        `/parameter_setups?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.parameterSetups = parameterSetups.data.data;
      this.count = parameterSetups.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let parameterSetups = await axios.get(
        `/parameter_setups?search=${this.searchData}`
      );
      this.parameterSetups = parameterSetups.data.data;
      this.count = parameterSetups.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Parameter Setup Data";
      this.parameterSetups_excel = [];
      let ExportparameterSetups = [];
      ExportparameterSetups = await axios.get(`/parameter_setups`);
      this.ExportparameterSetups = ExportparameterSetups.data.data;
      let sr_no = 1;
      this.ExportparameterSetups.forEach((parameterSetup) => {
        this.parameterSetups_excel.push({
          sr_no: sr_no,
          vessel_name: parameterSetup.vessel ? parameterSetup.vessel.name : "",
          title: parameterSetup ? parameterSetup.title : "",
          machinary_group: parameterSetup.marchinery_group
            ? parameterSetup.marchinery_group.name
            : "",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=parameter_setups`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
